import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=3cd3ca4a&"
import script from "./ProductSearch.vue?vue&type=script&lang=js&"
export * from "./ProductSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/myraj/m247/git/landing-pages/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd3ca4a')) {
      api.createRecord('3cd3ca4a', component.options)
    } else {
      api.reload('3cd3ca4a', component.options)
    }
    module.hot.accept("./ProductSearch.vue?vue&type=template&id=3cd3ca4a&", function () {
      api.rerender('3cd3ca4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ProductSearch.vue"
export default component.exports